export const toastContainerElement: HTMLDivElement =
  document.createElement('div')
const popoverContainer = document.getElementById('popover-portal-container')

// This if/else is for unit tests that don't use the index.html file
if (popoverContainer) {
  popoverContainer.appendChild(toastContainerElement)
} else {
  document.body.appendChild(toastContainerElement)
}

let idCounter = 100 // arbitrarily high number to get 2 character ids

/**
 * Create a toast
 * @param {Object} options - toast options.
 * @param {('info'|'success'|'error')} [toast.type = 'info'] - Type of toast.
 * @param {string} [toast.time = 5000] - Duration of toast in ms.
 * @param {string|function} toast.text - Content of the toast.
 *                                       If a function will be called with argument `{close, item }` where close
 *                                       can be used to close the toast
 * @param {string} [toast.closeOnClick = true] - Allow toast to be closed on click
 * @param {string} [toast.testKey = ''] - Used as the value of the `data-test-toast` attribute for e2e test hooks
 */

type ToastType = 'info' | 'success' | 'error'

export interface ToastOptions {
  type?: ToastType
  time?: number
  text?: string | React.ReactNode | ToastDynamicContent
  action?: React.ReactNode
  closeOnClick?: boolean
  testKey?: string
}

export type ToastDynamicContent = ({
  close,
  toast
}: {
  close: () => void
  toast: ToastOptions
}) => React.ReactNode

export default function toast({
  type = 'info',
  text = '',
  action,
  time,
  closeOnClick = true,
  testKey = ''
}: ToastOptions): void {
  const id = (++idCounter).toString(36) // generate base36 ids

  const toast = {
    type,
    text,
    action,
    time: time == null ? (action ? 10000 : 5000) : time,
    closeOnClick,
    testKey,
    createdAt: Date.now(),
    endAt: Date.now() + time,
    id,
    enabled: true
  }

  toastContainerElement.dispatchEvent(
    new CustomEvent('toast:add', {
      detail: toast
    })
  )
}
